var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVoxApplication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13218_14916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0064 4.47158C21.2174 4.47095 21.3885 4.30041 21.3892 4.08944C21.3904 3.99406 21.3538 3.90247 21.2868 3.83425H21.3254C21.5357 3.83362 21.7062 3.66371 21.7075 3.45337C21.7088 3.35357 21.6696 3.25693 21.5995 3.18618C21.8042 3.1426 21.9355 2.94174 21.8926 2.73709C21.8762 2.65939 21.8364 2.58928 21.7782 2.53559C21.9286 2.4819 22.029 2.33788 22.0265 2.17745C22.0259 1.96711 21.8547 1.79594 21.6443 1.79531H20.4335C20.3305 1.79341 20.2471 1.71256 20.2421 1.61087C20.3823 1.22051 20.4474 0.807412 20.4335 0.393053C20.4392 0.182084 20.2731 0.00585912 20.0621 0.000174318C19.8505 -0.00614213 19.6749 0.159979 19.6686 0.37158C19.6686 0.378528 19.6686 0.386105 19.6686 0.393053C19.6686 1.362 18.5404 1.909 18.5215 1.92289V3.96185C18.9737 3.96185 19.0053 4.47158 19.8593 4.47158H21.0064Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1386 4.02559V1.85904C18.1386 1.71819 18.0249 1.60449 17.884 1.60449H16.9277V4.28077H17.884C18.0249 4.28014 18.1386 4.16645 18.1386 4.02559Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58451 11.4595C4.79548 11.4589 4.96665 11.2877 4.96728 11.0773C4.96854 10.982 4.93192 10.8897 4.86496 10.8222H4.9035C5.11447 10.8215 5.285 10.6504 5.28626 10.4394C5.2869 10.3396 5.24774 10.2436 5.17762 10.1722C5.38228 10.1293 5.51365 9.92839 5.4707 9.7231C5.45428 9.64604 5.41448 9.57593 5.35637 9.52224C5.5067 9.46855 5.60651 9.32516 5.60461 9.16536C5.60398 8.95439 5.4328 8.78384 5.22246 8.78258H4.0116C3.90928 8.78005 3.82717 8.69984 3.82148 8.59814C3.96171 8.20779 4.0255 7.79532 4.0116 7.38096C4.01729 7.16999 3.85118 6.99376 3.64021 6.98745C3.42861 6.98176 3.253 7.14788 3.24668 7.35885C3.24668 7.36643 3.24668 7.37338 3.24668 7.38096C3.24668 8.3499 2.11856 8.89691 2.09961 8.9108V10.9497C2.55187 10.9497 2.58346 11.4595 3.43744 11.4595H4.58451Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71672 11.0135V8.84635C1.71672 8.70612 1.60301 8.59243 1.46215 8.5918H0.505859V11.2681H1.46215C1.60301 11.2681 1.71672 11.1537 1.71672 11.0135Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28906 14.2617H3.23653V15.2092H2.28906V14.2617Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28906 12.3672H3.23653V13.3147H2.28906V12.3672Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28906 18.0518H3.23653V18.9992H2.28906V18.0518Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28906 16.1572H3.23653V17.1047H2.28906V16.1572Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 10.1562H8.60372V11.1037H7.65625V10.1562Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 12.0518H8.60372V12.9992H7.65625V12.0518Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 6.36621H8.60372V7.31368H7.65625V6.36621Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 8.26172H8.60372V9.20919H7.65625V8.26172Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6055 14.5781H15.5529V15.5256H14.6055V14.5781Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6055 12.6826H15.5529V13.6301H14.6055V12.6826Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 12.999H19.6584V13.9465H18.7109V12.999Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 9.20898H19.6584V10.1565H18.7109V9.20898Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 11.1035H19.6584V12.051H18.7109V11.1035Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 5.41895H19.6584V6.36641H18.7109V5.41895Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 7.31348H19.6584V8.26094H18.7109V7.31348Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7637 12.3672H24.7111V13.3147H23.7637V12.3672Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7637 14.2617H24.7111V15.2092H23.7637V14.2617Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7637 18.0518H24.7111V18.9992H23.7637V18.0518Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7637 16.1572H24.7111V17.1047H23.7637V16.1572Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7637 10.4717H24.7111V11.4191H23.7637V10.4717Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1326 23.1051V19.9078H22.3427V21.526H20.7636V14.8938H17.6054V19.3153H16.6579V16.4729H13.4997V21.526H12.2364V18.9995H10.0257V13.9463H6.23578V21.526H4.65667V19.9469H3.23547H2.288H0.866805V23.1051H-0.396484V25.0001H27.3959V23.1051H26.1326Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0785 11.7351C15.0785 11.7351 16.9735 10.2861 16.9735 9.1157C16.9735 8.33562 15.7809 7.49995 15.0785 8.89273C14.3761 7.49995 13.1836 8.33562 13.1836 9.1157C13.1836 10.2861 15.0785 11.7351 15.0785 11.7351Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2367 9.52517C24.2367 9.52517 26.1317 8.07618 26.1317 6.90574C26.1317 6.12566 24.9391 5.28999 24.2367 6.68277C23.5343 5.28999 22.3418 6.12566 22.3418 6.90574C22.3418 8.07618 24.2367 9.52517 24.2367 9.52517Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13126 5.41872C8.13126 5.41872 10.0262 3.96973 10.0262 2.79929C10.0262 2.01921 8.83365 1.18355 8.13126 2.57632C7.42887 1.18355 6.23633 2.01921 6.23633 2.79929C6.23633 3.96973 8.13126 5.41872 8.13126 5.41872Z",
    fill: "#E9E9F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13218_14916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoxApplication);
export default __webpack_public_path__ + "static/media/icon-vox-application.b015a1b01a017f68b6adca8cdc42c2e5.svg";
export { ForwardRef as ReactComponent };